import { useEffect, useState } from "react";
import {
  IUseNpsRatingForm,
  IUseNpsRatingFormProps
} from "./nps-rating-form.types";

export const useNpsFormRating = ({
  submitNpsFeedback,
  onClose,
  handleScaleChange
}: IUseNpsRatingFormProps): IUseNpsRatingForm => {
  const [scale, setScale] = useState("");
  useEffect(() => {
    if (scale) handleScaleChange(scale);
  }, [scale, handleScaleChange]);

  const label = {
    start: "0: Nggak mau",
    end: "10: Pastinya!"
  };
  const handleSubmit = () => {
    submitNpsFeedback(scale);
  };

  const handleClickSkip = () => {
    onClose(scale);
  };

  return { scale, setScale, label, handleSubmit, handleClickSkip };
};
